import { createReducer } from 'reduxsauce';
import Immutable from 'seamless-immutable';
import i18n from 'i18next';
import { AppTypes } from '../actions/AppActions';

/* ------------- Initial App State ------------- */
export const INITIAL_STATE = Immutable({
  lang: i18n.language,
});

/* ------------- Reducers ------------- */
export const onLangChanged = (state, { lang }) => state.merge({ lang });

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
  [AppTypes.LANGUAGE_CHANGED]: onLangChanged,
});

/* ------------- Selectors ------------- */
export const getLanguage = (state) => state.app.lang;



// WEBPACK FOOTER //
// ./src/state/reducers/AppReducer.js